// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"1de5f737","2":"36e68ff9","3":"d0013b6b","4":"e24a469c","5":"e6e61ef1","6":"98768224","7":"72ec3fae"}[chunkId] + ".js";
};